import React from "react";
import warningIcon from "assets/images/warning.png";

const GameNotFoundModal = ({ text, btn_text, onPress, onClose }) => {
  return (
    <div className="invalid-code-modal" onClick={onClose}>
      <div className="modal-inner" onClick={(e) => e.stopPropagation()}>
        <img alt="" className="warning-icon" src={warningIcon} />
        <span className="warning-text">{text}</span>
        <button onClick={onPress} className="try-again-btn">
          {btn_text}
        </button>
      </div>
    </div>
  );
};

export default GameNotFoundModal;
